import { Icon } from '../icon';
import { IconButton } from '@chakra-ui/react';
import { Column } from '@tanstack/react-table';
import styles from './SortingIcon.module.css';

const SortingIcon: React.FC<{
  column: Column<Record<any, any>>;
  onIconClick?: () => void | (() => void);
}> = ({ column, onIconClick }) => {
  return column.getCanSort() ? (
    column.getIsSorted() ? (
      column.getIsSorted() === 'desc' ? (
        <IconButton
          aria-label="sorting-desc"
          variant="ghost"
          minH="unset"
          minW="unset"
          height="unset"
          p={0}
          onClick={onIconClick}
          icon={<Icon name="sorting-desc" className={styles.icon} />}
        />
      ) : (
        <IconButton
          aria-label="sorting-asc"
          variant="ghost"
          minH="unset"
          minW="unset"
          height="unset"
          p={0}
          onClick={onIconClick}
          icon={<Icon name="sorting-asc" className={styles.icon} />}
        />
      )
    ) : (
      <IconButton
        aria-label="sorting-default"
        variant="ghost"
        minH="unset"
        minW="unset"
        height="unset"
        p={0}
        onClick={onIconClick}
        icon={<Icon name="sorting-default" className={styles.icon} />}
      />
    )
  ) : null;
};

export default SortingIcon;
